<template>
	<div class="title-row"  @click="toggleExpansion">
		<el-row>
			<el-col :span="18">
				<h2>{{title}}</h2>
			</el-col>
			<el-col class="expandable-icon" :span="6">
				<i :class="icon_class"></i>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default{
	props: {
		title: String,
		isExpanded: Boolean
	},
	computed: {
		icon_class: function(){
			return {
				'el-icon-plus': !this.isExpanded,
				'el-icon-minus': this.isExpanded
			}
		}
	},
	methods: {
		toggleExpansion(){
			this.$emit('toggleExpansion');
		}
	}
}
</script>

<style scoped>
.title-row{
	cursor:pointer;
	transition: all .1s linear;
}

.title-row:hover{
	color: #359DB4;
}

h2, .expandable-icon{
	font-size:1.2em;
	margin:0;
}

.expandable-icon{
	text-align: right;
}
</style>
